import { cn } from "@/lib/utils"

interface BookDetailSkeletonProps {
  className?: string
}

export function BookDetailSkeleton({ className }: BookDetailSkeletonProps) {
  return (
    <div className={cn("min-h-screen bg-background", className)}>
      {/* Header */}
      <header className="border-b border-border/50 bg-background/95 backdrop-blur-sm">
        <div className="container mx-auto px-4 py-3 sm:py-4 flex items-center gap-3">
          <div className="h-10 w-20 sm:h-9 sm:w-24 bg-muted rounded-lg animate-pulse" />
          <div className="h-6 w-40 bg-muted rounded animate-pulse" />
        </div>
      </header>

      {/* Main */}
      <main className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {/* Main content (stacked on mobile/tablet) */}
          <div className="md:col-span-2 lg:col-span-2 space-y-6">
            {/* Card: Info do Livro */}
            <div className="bg-card rounded-xl shadow-sm border p-6">
              <div className="flex flex-col xs:flex-row gap-4 sm:gap-6">
                <div className="flex-shrink-0">
                  <div className="w-28 xs:w-32 sm:w-36 aspect-[3/4] rounded-lg bg-muted animate-pulse" />
                </div>
                <div className="flex-1">
                  <div className="mb-3 space-y-2">
                    <div className="h-7 w-2/3 bg-muted rounded animate-pulse" />
                    <div className="h-4 w-1/3 bg-muted/80 rounded animate-pulse" />
                  </div>
                  <div className="flex gap-3 sm:gap-2">
                    <div className="h-12 sm:h-10 w-40 bg-muted rounded-lg animate-pulse" />
                    <div className="h-12 sm:h-10 w-40 bg-muted rounded-lg animate-pulse" />
                  </div>
                </div>
              </div>
            </div>
            {/* Card: Detalhes + Funil */}
            <div className="bg-card rounded-xl shadow-sm border p-6">
              <div className="mb-4 h-6 w-32 bg-muted rounded animate-pulse" />
              <div className="grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-3 gap-6 mb-6">
                <div className="h-10 w-full bg-muted rounded animate-pulse" />
                <div className="h-10 w-full bg-muted rounded animate-pulse" />
                <div className="h-10 w-full bg-muted rounded animate-pulse" />
              </div>
              <div className="flex items-center justify-between mb-3">
                <div className="h-5 w-40 bg-muted rounded animate-pulse" />
                <div className="h-4 w-10 bg-muted rounded animate-pulse" />
              </div>
              <div className="h-2 w-full bg-muted rounded-full animate-pulse mb-2" />
              <div className="flex justify-between items-center">
                {Array.from({ length: 5 }).map((_, i) => (
                  <div key={i} className="flex flex-col items-center gap-2">
                    <div className="w-8 h-8 rounded-full bg-muted animate-pulse" />
                    <div className="h-3 w-16 bg-muted/70 rounded animate-pulse" />
                  </div>
                ))}
              </div>
            </div>
          </div>
          {/* Sidebar */}
          <div className="md:col-span-2 lg:col-span-1 space-y-6">
            <div className="bg-card rounded-xl shadow-sm border p-6">
              <div className="mb-4 h-5 w-40 bg-muted rounded animate-pulse" />
              {Array.from({ length: 4 }).map((_, i) => (
                <div key={i} className="flex items-center justify-between p-4 sm:p-3 bg-muted/50 rounded-lg mb-3">
                  <div className="h-4 w-40 bg-muted/80 rounded animate-pulse" />
                  <div className="h-10 sm:h-9 w-24 bg-muted rounded-lg animate-pulse" />
                </div>
              ))}
            </div>
            <div className="rounded-xl border border-border/60 bg-muted/40 p-6">
              <div className="flex items-center justify-between">
                <div className="h-4 w-48 bg-muted rounded animate-pulse" />
                <div className="h-4 w-16 bg-muted rounded animate-pulse" />
              </div>
              <div className="mt-3 h-12 sm:h-10 w-full bg-muted rounded-lg animate-pulse" />
            </div>
          </div>
        </div>
      </main>
    </div>
  )
}

